export default __webpack_public_path__ + "static/media/flag-it-CH.8301f6ec.png";